export default __webpack_public_path__ + "static/1-b332a8ab56e93868e82e9f80276c1d7c.jpg";